<lib-modal
  [visible]="visible()"
  [title]="'requirements.issuePicker.title' | translate"
  [contentTemplate]="contentTemplate"
  [showButtons]="false"
  (cancel)="onClose()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #content>
  <div class="ipm">
    <p class="ipm__subtitle">{{ 'requirements.issuePicker.subtitle' | translate }}</p>

    @if (hasProviderChoice()) {
      <div
        class="ipm__providers"
        role="tablist"
        [attr.aria-label]="'requirements.issuePicker.providerSwitchAria' | translate"
      >
        @for (p of providers(); track p.id) {
          <button
            type="button"
            role="tab"
            class="ipm__provider"
            [class.ipm__provider--active]="integration()?.id === p.id"
            [attr.aria-selected]="integration()?.id === p.id"
            [style.--pc]="providerColor(p.providerType)"
            (click)="selectProvider(p)"
          >
            <span class="ipm__provider-dot" aria-hidden="true"></span>
            {{ providerLabel(p.providerType) }}
          </button>
        }
      </div>
    }

    @if (integration()) {
      <div class="ipm__banner">
        <app-provider-badge
          size="sm"
          [providerType]="integration()!.providerType"
          [label]="providerLabel(integration()!.providerType)"
        ></app-provider-badge>
        <span class="ipm__banner-text">
          {{ 'requirements.issuePicker.connectedWith' | translate }}
          <strong>{{ boardHost() }}</strong>
          @if (integration()!.projectKey) {
            &nbsp;·&nbsp;
            {{ aliasLabelKey() | translate }}
            <strong data-testid="issue-picker-alias">{{ integration()!.projectKey }}</strong>
          }
        </span>
      </div>
    }

    <div class="ipm__search">
      <svg class="ipm__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8" />
        <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
      <input
        class="ipm__search-input"
        type="text"
        [value]="search()"
        (input)="onSearchInput($event)"
        [placeholder]="'requirements.issuePicker.searchPlaceholder' | translate"
        [attr.aria-label]="'requirements.issuePicker.searchPlaceholder' | translate"
      />
    </div>

    @if (loading()) {
      <div class="ipm__loading">
        <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (errorKey()) {
      <p class="ipm__error">
        {{ errorKey()! | translate: trackerError()?.params }}
        @if (trackerError()?.accountLink) {
          <a data-testid="tracker-error-account" routerLink="/account">{{ trackerErrorKeys.toAccount | translate }}</a>
        }
      </p>
    } @else if (filtered().length === 0) {
      <p class="ipm__empty">{{ 'requirements.issuePicker.noResults' | translate }}</p>
    } @else {
      <div class="ipm__list" role="radiogroup">
        @for (issue of filtered(); track issue.id) {
          <button
            type="button"
            role="radio"
            class="ipm__row"
            [class.ipm__row--selected]="selectedIssue()?.id === issue.id"
            [attr.aria-label]="issue.key + ' ' + issue.summary"
            [attr.aria-checked]="selectedIssue()?.id === issue.id"
            (click)="onSelectRow(issue)"
          >
            <span class="ipm__radio" aria-hidden="true">
              <span class="ipm__radio-dot"></span>
            </span>
            <span class="ipm__key">{{ issue.key }}</span>
            <span class="ipm__info">
              <span class="ipm__summary">{{ issue.summary }}</span>
              @if (issue.assigneeDisplayName || issue.statusName) {
                <span class="ipm__meta">
                  {{ issue.assigneeDisplayName }}{{ issue.assigneeDisplayName && issue.statusName ? ' · ' : ''
                  }}{{ issue.statusName }}
                </span>
              }
            </span>
            <span [class]="'ipm__type-badge ipm__type-badge--' + issueTypeClass(issue.issueTypeName)">
              <span class="ipm__type-dot"></span>
              @if (issue.issueTypeName) {
                {{ issue.issueTypeName }}
              } @else {
                {{ 'requirements.issuePicker.issueTypeMissing' | translate }}
              }
            </span>
          </button>
        }
      </div>
    }

    <div class="ipm__manual">
      <span class="ipm__manual-label">{{ 'requirements.issuePicker.manualIdLabel' | translate }}</span>
      <div class="ipm__manual-field">
        <input
          class="ipm__manual-input"
          type="text"
          [value]="manualId()"
          (input)="onManualIdInput($event)"
          [placeholder]="'requirements.issuePicker.manualIdPlaceholder' | translate"
          [attr.aria-label]="'requirements.issuePicker.manualIdPlaceholder' | translate"
        />
      </div>
    </div>

    <div class="ipm__footer">
      <button type="button" class="ipm__btn ipm__btn--cancel" (click)="onClose()">
        {{ 'requirements.issuePicker.cancel' | translate }}
      </button>
      <button type="button" class="ipm__btn ipm__btn--confirm" [disabled]="!canConfirm()" (click)="onConfirm()">
        <mat-icon class="ipm__btn-icon" aria-hidden="true">check</mat-icon>
        {{ 'requirements.issuePicker.confirm' | translate }}
      </button>
    </div>
  </div>
</ng-template>
